





import { defineComponent } from '@nuxtjs/composition-api';
export default defineComponent({
  name: 'BaseContentPage',
  inject: ['provided'],
  props: {
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: [String, Array],
      default: '',
    },
  },
  computed: {
    isActive(): any {
      // @ts-ignore migrated from ui-library
      return this.provided.active.toLowerCase() === this.title.toLowerCase();
    },
  },
  mounted() {
    const item = {
      title: this.title,
      icon: this.icon,
    };
    // @ts-ignore migrated from ui-library
    this.$parent.items.push(item);
  },
});
